module.exports = __webpack_public_path__ + "static/media/pepole.e64f47ad.png";